<template>
	<Toast />
	<Dialog modal v-model:visible="visible" @show="focusInputCaptcha" :pt="{
		content: { style: 'width: 100%;' },
		root: { style: 'max-width: 24rem; width: 90%; border-radius: 6px; overflow: hidden; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); margin: auto;' },
		closeButton: { style: 'display: none' },
		closeButtonIcon: { style: 'display: none' }
	}" :closeOnEscape="false" @after-hide="onAfterHide">

		<div ref="contentdiv11111" id="content" class="flex flex-column  boxErro">

			<div class="flex flex-column justify-content-center align-items-center text-center flex-wrap p-2"
				style="font-weight: bold">
				{{ msg }}
			</div>
			<div class="flex  w-full flex-column justify-content-around p-2">
				<div
					class="flex  w-full flex-column justify-content-center align-items-center flex-nowrap align-content-center">
					Digite [ {{ captchaGerado }} ] para confirmar leitura.
				</div>

				<div class="flex  w-full flex-column justify-content-around p-2">
					<R3Input ref="inputCaptchaRef" type="Number" v-model:input-value="captchaConfirmacao"
						@keydown="onCaptchaConfirmacaoKeydown" inputID="inputCaptcha"></R3Input>
				</div>
				<div class="flex w-full gap-2 p-2">
					<Button @click="visible = false" label="Cancelar" severity="secondary" class="p-button-outlined flex-1">
					</Button>
					<Button @click="onCaptchaConfirmButtonClick" label="Confirma" class="flex-1">
					</Button>
				</div>
			</div>

		</div>
	</Dialog>
</template>

<script setup lang="ts">
	import type { R3NumberCaptchaExposedProps } from '@/types/components/R3/numberCaptcha.types';


	// import { useToast } from 'primevue/usetoast';

	const toast = useToast();
	const contentdiv11111 = ref(null);
	const inputteste = ref(null);

	let functionClose: () => unknown;

	const msg = ref("");
	const props = withDefaults(defineProps<
		{
			mostrarCaptcha: boolean, tempoDeErro?: number, tempoDeTransicaoParaPadrao?: number
		}>(), {
		mostrarCaptcha: false,
		tempoDeErro: 500,
		tempoTransicaoParaPadrao: 5000,
	});

	const visible = ref();
	watch(() => props.mostrarCaptcha, (value) => {
		visible.value = value
	})

	const tempoDeErro = ref(`${props.tempoDeErro}ms`);
	const tempoDeTransicaoparaPadrao = ref(`${props.tempoDeTransicaoParaPadrao}ms`);

	const captchaConfirmacao = ref<string | null>();

	watch(captchaConfirmacao, (value) => {
		if (value === undefined || value === null) {
			return;
		}
		// Limita a 4 dígitos; exclusão só no botão/tecla Confirma ou Enter.
		const strValue = String(value).replace(/\D/g, "");
		if (strValue.length > 4) {
			captchaConfirmacao.value = strValue.slice(0, 4);
		}
	})

	// function handleInput(event: KeyboardEvent) {
	//     if (event.key === 'Enter') {
	//       OnCaptchaConfirmButtonClick()
	//     } else {

	//       captchaConfirmacao.value = event
	//     }
	//   }
	// }

	const captchaGerado = ref<Number>(0);

	const emits = defineEmits(['confirmClick', 'captchaClosed', 'captchaOpened']);

	function gerarNumCaptcha() { // min and max included 

		let max = 9999;
		let min = 1000;

		return Math.floor(Math.random() * (max - min + 1) + min);

	}

	onMounted(() => {

		console.log(contentdiv11111);
		console.log(inputteste);

		watch(() => props.mostrarCaptcha, (val_novo, val_antigo) => {

			visible.value = val_novo;

			if (val_novo == true) {

				captchaGerado.value = gerarNumCaptcha();
				setTimeout(() => document.getElementById('inputCaptcha').focus(), 1);
			}


		});


	});


	function onCaptchaConfirmacaoKeydown(event: KeyboardEvent) {
		// alert(`confirma keydown: ${event.key}`);
		if (event.key === 'Enter') {
			onCaptchaConfirmButtonClick()
		}

	}




	let confirmando = false;
	/** true quando fechou por confirmação válida — não emitir captchaClosed (cancelamento). */
	let fechouPorConfirmacao = false;

	function onAfterHide() {
		if (fechouPorConfirmacao) {
			fechouPorConfirmacao = false;
			return;
		}
		emits("captchaClosed");
	}

	function onCaptchaConfirmButtonClick() {
		if (confirmando) return;

		// make sure v-model is up to date; R3Input may not emit immediately when the user
		// has not pressed Enter, so read the DOM value as fallback.
		const domInput = document.getElementById('inputCaptcha') as HTMLInputElement | null;
		if (domInput) {
			captchaConfirmacao.value = domInput.value;
		}

		const digitado = String(captchaConfirmacao.value ?? "").replace(/\D/g, "");
		const esperado = String(captchaGerado.value ?? "").replace(/\D/g, "");

		if (digitado.length > 0 && digitado === esperado) {
			confirmando = true;
			fechouPorConfirmacao = true;
			emits('confirmClick');
			visible.value = false;
			captchaConfirmacao.value = null;
			confirmando = false;
		} else {
			toast.add({ severity: 'error', summary: 'Erro', detail: "Captcha Incorreto", life: props.tempoDeErro });
			captchaConfirmacao.value = null;
			nextTick(() => focarCaptcha());
		}

		if (typeof functionClose === 'function') {
			functionClose();
		}
	}

	function show(pMsg: string) {
		msg.value = pMsg;
		visible.value = true;
		captchaConfirmacao.value = null;
		captchaGerado.value = gerarNumCaptcha();
	}

	function focusInputCaptcha() {
		emits('captchaOpened')
		changeColor();
		focarCaptcha();
		// setTimeout(() => document.getElementById('inputCaptcha')!.focus(), 1);
	}

	function changeColor() {
		setTimeout(() => {
			// contentdiv!.style.transitionDuration = props.tempoDeErro.toString();
			const contentdiv11111ClassList = useClassList(contentdiv11111);
			contentdiv11111ClassList.removeClass("boxErroOriginal");
			contentdiv11111ClassList.addClass("boxErro");

			// contentdiv11111.value.style.transitionDuration = props.tempoDeErro.toString();
			setTimeout(() => {
				contentdiv11111ClassList.removeClass("boxErro");
				contentdiv11111ClassList.addClass("boxErroOriginal");

				// contentdiv!.style.transitionDuration = props.tempoDeErro.toString();

			}, 0.1);
		}, 0.1);
	}

	function showAlert(pMsg: string, afterHide: () => void) {
		console.log("msg alert", pMsg)
		visible.value = true;
		show(pMsg);

		functionClose = afterHide;
		// const contentdiv = document.getElementById('content');


	}

	function close() {

		visible.value = false;

	}

	function onClose(customFunction: () => unknown) {
		customFunction();
	}

	defineExpose({ show, close, showAlert, onClose });


	const inputCaptchaRef = ref<R3NumberCaptchaExposedProps>(null);

	// function focarCaptcha() {
	//   useExpose(inputCaptchaRef).focusInput();
	// }

	function focarCaptcha() {

		setTimeout(() => document.getElementById('inputCaptcha')!.focus(), 50);

	}

</script>

<style scoped>
	.boxErroOriginal {
		background-color: transparent;
		-webkit-transition-property: background-color;
		-webkit-transition-duration: v-bind(tempoDeTransicaoParaPadrao);
		-webkit-transition-timing-function: ease-in-out;
		transition-property: background-color;
		transition-duration: 500ms;
		transition-timing-function: ease-in-out;
	}

	.boxErro {
		background-color: #ff0000;
		-webkit-transition-property: background-color;
		-webkit-transition-duration: v-bind(tempoDeErro);
		-webkit-transition-timing-function: ease-in-out;
		transition-property: background-color;
		transition-duration: 500ms;
		transition-timing-function: ease-in-out;
	}
</style>